import { Resource } from './resource';
import {
  CaptureGroup,
  MultiPointInstallation,
  MultiPointInstallationAccuracy,
} from './api';

export type MultiPointInstallationCaptureGroupState = {
  resource: Resource<{
    captureGroup: CaptureGroup;
    mpi: MultiPointInstallation;
    mpiAccuracy: MultiPointInstallationAccuracy;
  }>;
};

export enum MultiPointInstallationCaptureGroupActionTypes {
  MULTI_POINT_INSTALLATION_CAPTURES_GROUP_REQUEST_LOAD = 'MULTI_POINT_INSTALLATION_CAPTURES_GROUP_REQUEST_LOAD',
  MULTI_POINT_INSTALLATION_CAPTURES_GROUP_REQUEST_RELOAD = 'MULTI_POINT_INSTALLATION_CAPTURES_GROUP_REQUEST_RELOAD',
  MULTI_POINT_INSTALLATION_CAPTURES_GROUP_LOADING = 'MULTI_POINT_INSTALLATION_CAPTURES_GROUP_LOADING',
  MULTI_POINT_INSTALLATION_CAPTURES_GROUP_LOAD_COMPLETE = 'MULTI_POINT_INSTALLATION_CAPTURES_GROUP_LOAD_COMPLETE',
  MULTI_POINT_INSTALLATION_CAPTURES_GROUP_ERROR = 'MULTI_POINT_INSTALLATION_CAPTURES_GROUP_ERROR',
}

export type MultiPointInstallationCaptureGroupLoadAction = {
  type:
    | MultiPointInstallationCaptureGroupActionTypes.MULTI_POINT_INSTALLATION_CAPTURES_GROUP_REQUEST_LOAD
    | MultiPointInstallationCaptureGroupActionTypes.MULTI_POINT_INSTALLATION_CAPTURES_GROUP_REQUEST_RELOAD;
  mpiId: MultiPointInstallation['id'];
  captureGroupId: CaptureGroup['id'];
};

export type MultiPointInstallationCaptureGroupAction =
  | MultiPointInstallationCaptureGroupLoadAction
  | {
      type: MultiPointInstallationCaptureGroupActionTypes.MULTI_POINT_INSTALLATION_CAPTURES_GROUP_LOADING;
    }
  | {
      type: MultiPointInstallationCaptureGroupActionTypes.MULTI_POINT_INSTALLATION_CAPTURES_GROUP_LOAD_COMPLETE;
      captureGroup: CaptureGroup;
      mpi: MultiPointInstallation;
      mpiAccuracy: MultiPointInstallationAccuracy;
    }
  | {
      type: MultiPointInstallationCaptureGroupActionTypes.MULTI_POINT_INSTALLATION_CAPTURES_GROUP_ERROR;
      error: Error;
    };
